import { pdfSlugs } from './PdfRouter';

export function PdfIndex() {
  return (
    <div className="min-h-screen bg-ink-base p-8">
      <div className="max-w-2xl mx-auto">
        <a href="#" className="text-sm text-brand-primary mb-6 inline-block">
          &larr; Back to site
        </a>
        <h1 className="text-2xl font-bold text-text-primary mb-2">PDF Flyers</h1>
        <p className="text-text-secondary mb-8">
          Click a flyer to preview, then use Cmd+P (or Ctrl+P) to print/save as PDF.
        </p>
        <div className="grid gap-3">
          {pdfSlugs.map(({ slug, label }) => (
            <a
              key={slug}
              href={`#pdf/${slug}`}
              className="glass-card px-5 py-4 flex items-center justify-between hover:shadow-md transition-all"
            >
              <span className="font-medium text-text-primary">{label}</span>
              <span className="text-text-muted text-sm">&rarr;</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
